import { Autocomplete, Box, Checkbox, Grid, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import SelectFormItem from "components/Input/Select";
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { CheckboxFormItem, RadioForm, TextBoxForm } from "components/Input";
import Divider from "components/Divider";
import "./Register.css";
import { FiArrowRight, FiArrowLeft } from "react-icons/fi";
import React from "react";
import { RegisterContext } from "..";
import { ColumnProps } from "components/TableUI/TableUI";
import TableUI from "components/TableUI";
import { BtnAdd, BtnDeleteTable, BtnViewTable } from "components/Button";
import { SendAPIFile } from "utilities/Axios";
import { FIleItem } from "./RegisterClass";
import { List } from "linqts";
import { Link } from "react-router-dom";
import { SwAlert } from "components/Alert";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
const StepForm7 = () => {
  const { arrFile, setarrFile, handleBack, isAgree, setisAgree, onSentData } = React.useContext(RegisterContext);
  const objSchema = yup.object().shape({
    sCode: yupFormSchemas.string("code", { required: true }),
    sType: yupFormSchemas.string("type", { required: true }),
    sRegion: yupFormSchemas.string("region", { required: true }),
    sLocation: yupFormSchemas.string("country name", { required: true }),
    cStatus: yupFormSchemas.string("status", { required: true }),
  });

  const form = useForm({
    resolver: yupResolver(objSchema),
    shouldUnregister: false,
    shouldFocusError: true,
    mode: "all",
  });
  const ColumnData: ColumnProps[] = [{
    id: "nNo",
    name: "ลำดับ",
    width: "5%",
  },
  {
    id: "sFileName",
    name: "ชื่อไฟล์",
    width: "85%",
    cellAlign: "left"
  },
  {
    id: "Action",
    name: "",
    width: "10%",
    renderCell: (item) => {
      return (
        <div style={{ display: "inline-flex", textAlign: "center" }}>
          <BtnViewTable onClick={() => {
            const a = document.createElement('a');
            a.href = item.sFileUrl;
            a.target = "_blank";
            a.download = item.sFileUrl.split('/').pop();
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }} />
          <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDeleteFile(item) }} />
        </div>
      )
    }
  }]
  const onDeleteFile = (obj: FIleItem) => {
    SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
      setarrFile(new List<FIleItem>(arrFile || []).Where(w => w.nID != obj.nID).ToArray())
    });
  };
  const onUploadFile = () => {
    const onClickFile = document.getElementById("onCameraFile");
    if (onClickFile) {
      onClickFile.click();
    }
  }
  const _SendAPIFile = async (_FileItem) => {

    let lstFile_ = _FileItem.target.files;
    await SendAPIFile(lstFile_[0], (res: FIleItem[]) => {
      let _lstFile = new List<FIleItem>(res || []).FirstOrDefault(w => w.IsCompleted);
      let lstFile = new List<FIleItem>(arrFile || []).ToList();;
      if (_lstFile) {
        console.log("s", _lstFile);
        let macID = lstFile.Any() ? lstFile.Max(m => m.nID) + 1 : 1;
        let macNo = lstFile.Any() ? lstFile.Max(m => m.nNo) + 1 : 1;
        let data: FIleItem = {
          ..._lstFile,
          nID: macID,
          nNo: macNo,
        }
        setarrFile([...arrFile, { ...data }])
      }
      //   setobjFileImg(res[0]);
    }, (er) => {
      console.log("er", er);
    });

  }
  return (
    <FormProvider {...form}>
      <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
        <Grid item md={12} xs={12}>
          <Divider>อัปโหลดไฟล์ เพิ่มเติม เช่น Resume เป็นต้น</Divider>
        </Grid>
        <Grid item md={12} xs={12}>
          <TableUI column={ColumnData || []}
            row={arrFile || []} />
        </Grid>
        <Grid item md={12} xs={12}>
          <input style={{ display: "none" }} type="file" id="onCameraFile" accept="image/*,application/pdf,application/vnd.ms-excel" onChange={_SendAPIFile} />
          <BtnAdd onClick={onUploadFile} />
        </Grid>
        <Grid item md={12} xs={12}>
          <Divider>หนังสือยินยอมให้เปิดเผยข้อมูล </Divider>
        </Grid>
        <Grid item md={12} xs={12}>
          <div style={{ paddingLeft: "10px", paddingRight: "10px", display: "flex" }}>
            <div><Checkbox checked={isAgree} onChange={(e) => {
              console.log("e", e);
              setisAgree(e.target.checked)
            }} /></div>
            <div style={{ color: "rgb(102 102 102)", fontSize: "14px", marginTop: "14px" }}>ข้าพเจ้ายินยอมให้ บริษัท ("บริษัทฯ") และ/หรือบุคคลหรือนิติบุคคลที่บริษัทฯ เห็นควร ทำการเก็บรวบรวม
              ใช้ ปรับปรุง และเปิดเผยข้อมูลส่วนบุคคลที่เกี่ยวข้องกับข้าพเจ้า สำหรับใช้ในการสมัครงาน และสัมภาษณ์งาน รวมถึงยินยอม
              ให้ทำการตรวจสอบประวัติส่วนตัว ประวัติอาชญากรรม ประวัติการทำงานและประสบการณ์ที่ผ่านมาของข้าพเจ้าไป
              ยังบุคคล และ/หรือหน่วยงานต่างๆ ที่เกี่ยวข้อง เพื่อเป็นข้อมูลประกอบการพิจารณาคัดเลือกเข้าปฏิบัติงาน โดยข้าพเจ้า
              ยินยอมให้เปิดเผยข้อมูลดังนี้<br />
              &nbsp; &nbsp; &nbsp; &nbsp;1. รายละเอียดข้อมูลต่างๆ ที่ผู้สมัครงานได้กรอกในใบสมัครงานของบริษัทฯ เช่น การตรวจสอบบุคคลอ้างอิง บุคคลที่เกี่ยวข้อง ประวัติส่วนบุคคล และประวัติการทำงาน เป็นต้น <br />
              &nbsp; &nbsp; &nbsp; &nbsp;2. รายละเอียดข้อมูลต่างๆ ในเอกสารหรือหลักฐานแนบที่สมัครได้นำส่งให้บริษัทฯ ทุกช่องทางการสื่อสาร เช่น อีเมลล์ และเบอร์โทรศัพท์ เป็นต้น<br />
              &nbsp; &nbsp; &nbsp; &nbsp;โดยหนังสือฉบับนี้ ข้าพเจ้าอนุญาตให้บริษัท บริษัในเครือธุกิจ บุคคล องค์กร และ/หรือ หน่วยงานใดๆ ที่ได้รับมอบหมาย
              โดยชอบจากบริษัทฯ ในการเก็บรวบรวม ใช้ เปิดเผย แก้ไข เปลี่ยนแปลง ลบ โอน ประมวลผลข้อมูล หรือกระทำการใดๆ
              ต่อข้อมูลส่วนบุคคลของข้าพเจ้า ที่ข้าพเจ้าได้เปิดเผยต่อบริษัทฯ ตามหนังสือฉบับนี้ ไม่ว่าในรูปแบบใด ซึ่งบริษัทฯ
              ได้ระบุรายละเอียดขอบเขตการเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคลไว้ และหากข้าพเจ้าร้องขอ ข้าพเจ้ามีสิทธิเข้าถึง
              ข้อมูลส่วนบุคคล รวมถึงร้องขอให้บริษัทฯ ทำการลบหรือทำลาย หรือขอเพิกถอนความยินยอม บริษัทฯ จะดำเนินการลบทำลาย หรือเพิกถอน
              ข้อมูลส่วนบุคคลที่บริษัทฯ และ/หรือผู้ที่ได้รับมอบหมายจากบริษัทฯ ที่ได้จัดเก็บไว้ เมื่อได้รับการร้องขอ ทั้งนี้บริษัทฯ ดำเนินการภายใต้พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562 และกฎหมายลำดับรองที่
              สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลกำหนดไว้ข้าพเจ้าได้ทราบและเข้าใจข้อความข้างต้นเป็นอย่างดีโดย
              ตลอดแล้ว เห็นว่าถูกต้องตามเจตนาและความประสงค์ของข้าพเจ้าทุกประการ
            </div>
          </div>

        </Grid>
        <Grid item md={6} xs={6}>
          <Grid marginTop={4} container direction="row" alignItems="start" justifyContent="start" sx={{}}>
            <button className="buttonBack" onClick={handleBack}>
              <FiArrowLeft />
              <span>กลับ</span>
            </button>
          </Grid>
        </Grid>
        <Grid item md={6} xs={6}>
          <Grid marginTop={4} container direction="row" alignItems="end" justifyContent="end" sx={{}}>
            <button className="buttonSend" disabled={isAgree === false} onClick={onSentData}>
              <div className="svg-wrapper-1">
                <div className="svg-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path fill="currentColor" d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"></path>
                  </svg>
                </div>
              </div>
              <span>ส่งใบสมัคร</span>
            </button>
          </Grid>
        </Grid>
      </Grid>
    </FormProvider>
  )
};

export default StepForm7;
